
class UserStore {
    constructor() {
        this.user = {};
        this.isLoggedIn = false;
    }
}

export default new UserStore();
